import { MenuNode } from '@/views/models'
import { Menus } from '@/views/models/DefaultMenu'
import { findObjectByKeyValue } from '@/common/utils'

export default {
  state: {
    locale: 'zh-hant',
    menuList: Menus as MenuNode[],
    breadCrumbList: [] as MenuNode[],
  },
  getters: {
    locale: (state: any) => state.locale,
    menuList: (state: any) => state.menuList,
    breadCrumbList: (state: any) => state.breadCrumbList,
  },
  mutations: {
    setLocale(state: any, lang: string) {
      state.locale = lang
      //router.replace({ name: router.currentRoute.name, params: { lang } })
    },
    setMenu(state: any) {
      state.menuList = Menus
    },
    setBreadCrumb(state: any, targetRoute: any) {
      const pathArray = (targetRoute.path.split('/')).splice(2)
      state.breadCrumbList = pathArray.reduce((breadCrumbList: MenuNode[], path: string) => {
        const menuNode: MenuNode = findObjectByKeyValue(state.menuList, 'name', path)
        if (menuNode !== null) {
          breadCrumbList.push(menuNode)
        }
        return breadCrumbList
      }, [])
    },
  },
  actions: {},
  namespaced: true,
}
